<template>
  <b-modal id="already-exist-event-alert-modal" hide-footer
           :modal-class="`adp-modal adp-modal__no_footer mass-assignments-alert-modal`"
           :body-class="`adp-modal-body`">
    <template #modal-header-close>
      <button type="button" class="close adp-close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
      </button>
    </template>
    <template>
      <div class="mass-assignments-alert" style="padding-bottom: 24px" v-for="event in events">
        {{ $t('catalog.learning') }}{{ event.activity.name }}{{ $t('catalog.learning_already_exists_in_employee') }}
        {{ event.employee }}
        <br>
<!--        <p class="mass-assignments-alert-link" @click="goToMyIDP">-->
<!--          {{ $t('catalog.go_to_my_idp') }}-->
<!--        </p>-->
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "AlreadyExistEventAlertModal",
  components: {},
  props: {
    events: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {

    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>
